import {background} from '@chakra-ui/react'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        subtle: (props) => ({
            container: {
                borderColor: `${props.colorScheme || 'green'}.600`,
                borderWidth: 1,
                borderStyle: 'solid'
            }
        }),
        black: {
            container: {
                backgroundColor: 'black',
                color: 'white',
                padding: '16px 12px',
                borderRadius: '0'
            }
        },
        warning: {
            container: {
                background: 'alternativeWarning.100',
                border: 0,
                fontSize: 'sm',
                color: 'warningText',
                padding: 4
            }
        },
        custom: {
            container: {
                backgroundColor: '#FEF7E8'
            }
        },
        success: {
            container: {
                background: 'alertSuccessBG',
                color: 'successText',
                border: 0,
                fontSize: 'sm',
                padding: 4
            }
        }
    }
}
